import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import TagsToolContent from '../TagsToolContent';
import TagEditPopup from './TagEditPopup';
import useTagPopupsState from '../hooks/useTagPopupsState';
import { closePopup } from '../../../../../../components/popupPanel/popupActions';
import { TooltipAlignment } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import './TagsToolbarPopup.scss';
import { TagsToolbarPopupProps } from '../tagComponentPropTypes';
import { getRootBoardId } from '../../../../../../../common/users/utils/userPropertyUtils';

const TagsToolbarPopup: React.FC<TagsToolbarPopupProps> = (props) => {
    const { buttonSelector, currentUser, currentUserId } = props;

    const [showEditingPopup, setShowEditingPopup] = useState<boolean>(false);

    const toggleEditingPopup = (isOpen: boolean) => {
        setShowEditingPopup(isOpen);
    };

    const tagProps = useTagPopupsState(toggleEditingPopup);

    const {
        currentlyEditingTag,
        setCurrentlyEditingTagId,
        shareRootPath,
        showMoveMenu,
        showColorChange,
        handleClickMoveMenu,
        handleClickColorChange,
        userRootPath,
        contextRootsInCurrentPath,
    } = tagProps;

    const dispatch = useDispatch();
    const dismissPopups = () => {
        dispatch(closePopup(PopupIds.TAG_EDIT_MENU, true));

        setShowEditingPopup(false);
        setCurrentlyEditingTagId(null);
    };

    const userRootBoardId = getRootBoardId(currentUser);

    return (
        <ToolbarPopup
            buttonSelector={buttonSelector}
            alignment={TooltipAlignment.START}
            popupId={PopupIds.TAGS_TOOL}
            className={classNames('TagsPopup')}
            showArrow={false}
        >
            <TagsToolContent {...props} {...tagProps} closePopups={dismissPopups} />
            <TagEditPopup
                tag={currentlyEditingTag}
                showEditingPopup={showEditingPopup}
                showMoveMenu={showMoveMenu}
                onMoveMenuClick={handleClickMoveMenu}
                showColorMenu={showColorChange}
                onColorChangeClick={handleClickColorChange}
                shareRootPath={shareRootPath}
                closePopups={dismissPopups}
                userRootPath={userRootPath}
                contextRootsInCurrentPath={contextRootsInCurrentPath}
                userRootBoardId={userRootBoardId}
                currentUserId={currentUserId}
            />
        </ToolbarPopup>
    );
};

export default TagsToolbarPopup;
